import { AdditionalEquipment, CvhVehicleSearchRow, EkoProgram, NewPriceFormValues, ResidualValueFormValues, UsedPriceFormValues } from "./types";

export const transformEkoProgram = (res: any): EkoProgram => ({
  id: res.id,
  name: res.naziv,
});

// CVH zna vratiti "-" (ili prazno) kad vrijednost ne postoji — tretiraj to kao null.
const cleanCvhValue = (value: any): string | null => {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed === "" || trimmed === "-" || trimmed === "–" ? null : trimmed;
};

export const transformCvhVehicleSearchRow = (res: any): CvhVehicleSearchRow => ({
  jom: res.jom,
  name: res.name,
  yearFrom: res.yearFrom ?? null,
  yearTo: res.yearTo ?? null,
  power: res.power ?? null,
  fuelType: cleanCvhValue(res.fuelType),
  equipment: cleanCvhValue(res.equipment),
  image: res.image ?? "",
});

export const transformAdditionalEquipment = (res: any): AdditionalEquipment => ({
  id: res.cvhId,
  name: res.name,
  description: res.description,
  priceEur: res.priceEur,
  finalPriceEur: res.finalPriceEur,
  included: res.included,
  selected: res.selected,
});

export const transformResidualValueRequest = (formValues: ResidualValueFormValues): any => ({
  jom: formValues.jom,                                                    // JOM
  priceOnDate: formValues.priceOnDate,                                    // CijenaNaDatum
  firstRegistrationDate: formValues.firstRegistrationDate,                // DatumPrveRegistracije
  usedVehicle: formValues.usedVehicle || null,                            // RabljenoVozilo
  manualPriceEntry: formValues.manualPriceEntry || null,                  // RucniUnosCijeneVrijednostVozila
  mileageKm: formValues.mileageKm,                                       // BrojPrijedenihKilometara
  mileageAtContractEnd: formValues.mileageAtContractEnd,                  // KilometriNaKrajuUgovora
  financingStartDate: formValues.financingStartDate,                      // DatumPocetkaFinanciranja
  contractEndDate: formValues.contractEndDate,                            // DatumIstekaUgovora
  invoicePrice: formValues.invoicePrice,                                  // CijenaPremaRacunu
  ppmvByInvoice: formValues.ppmvByInvoice,                                // PPMVPremaRacunu
  co2: formValues.co2,                                                    // CO2
  numberOfSeats: formValues.numberOfSeats,                                // BrojSjedala
  electricRange: formValues.electricRange,                                // ElektricniDoseg
  enginePower: formValues.enginePower,                                    // SnagaMotora
  engineDisplacement: formValues.engineDisplacement,                      // ObujamMotora
  ecoProgramId: formValues.ecoProgramId,                                  // EKOProgramID
  ppmvPassengerVehicles: formValues.ppmvPassengerVehicles || null,        // PpmvOsobnaVozila
  additionalEquipmentFreeText: formValues.additionalEquipmentFreeText,    // DodatnaOpremaSlobodniUnosText
  additionalEquipmentFreePrice: formValues.additionalEquipmentFreePrice,  // DodatnaOpremaSlobodniUnosCijena
  additionalEquipment: formValues.additionalEquipment.length > 0
    ? formValues.additionalEquipment
    : null,                                                               // DodatnaOprema
});

export const transformNewPriceRequest = (formValues: NewPriceFormValues): any => ({
  jom: formValues.jom,
  priceOnDate: formValues.priceOnDate,
  firstRegistrationDate: formValues.firstRegistrationDate,
  co2: formValues.co2,
  numberOfSeats: formValues.numberOfSeats,
  electricRange: formValues.electricRange,
  enginePower: formValues.enginePower,
  engineDisplacement: formValues.engineDisplacement,
  ecoProgramId: formValues.ecoProgramId,
  deduction50PercentVAT: formValues.deduction50PercentVAT || null,
  ppmvPassengerVehicles: formValues.ppmvPassengerVehicles || null,
  additionalEquipmentFreeText: formValues.additionalEquipmentFreeText,
  additionalEquipmentFreePrice: formValues.additionalEquipmentFreePrice,
  additionalEquipment: formValues.additionalEquipment.length > 0
    ? formValues.additionalEquipment
    : null,
});

export const transformUsedPriceRequest = (formValues: UsedPriceFormValues): any => ({
  jom: formValues.jom,
  priceOnDate: formValues.priceOnDate,
  firstRegistrationDate: formValues.firstRegistrationDate,
  mileageKm: formValues.mileageKm,
  co2: formValues.co2,
  numberOfSeats: formValues.numberOfSeats,
  electricRange: formValues.electricRange,
  enginePower: formValues.enginePower,
  engineDisplacement: formValues.engineDisplacement,
  ecoProgramId: formValues.ecoProgramId,
  ppmvPassengerVehicles: formValues.ppmvPassengerVehicles || null,
  additionalEquipmentFreeText: formValues.additionalEquipmentFreeText,
  additionalEquipmentFreePrice: formValues.additionalEquipmentFreePrice,
  additionalEquipment: formValues.additionalEquipment.length > 0
    ? formValues.additionalEquipment
    : null,
});
